const BOOK_PAGE_TEMPLATE = `
    <section id="banner-component"></section>
    <section id="collection"></section>
`;

const BooksPage = Backbone.View.extend({

    id: "books-page",

    template: _.template(BOOK_PAGE_TEMPLATE),

    // The subcomponents of the page
    components: {
        banner: {},
        bookView: {}
    },

    collection: {},
    
    afterRender: function() {
        this.components.banner.afterRender();
        this.components.bookView.afterRender();
    },

    initialize: function() {
        // initialize the subcomponents
        this.components.banner = new BannerComponent();
        this.components.bookView = new DynamicBookCollectionView({ collection: this.collection });
    },

    render: function() {
        this.$el.html(this.template());
        this.$el.find("#banner-component").html(this.components.banner.render().el);
        this.$el.find("#collection").html(this.components.bookView.render().el);

        return this;
    },

});